require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-1.json") })
        }
      }, "path---blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-1!./.cache/json/blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-1.json
// module id = 760
// module chunks = 231608221292675